import { List, Record  } from 'immutable';

export const PracticeList = new Record({
  id: null,
  isNew: true,
  isPending: false,
  practiceIds: new List(),
  total: 0,
  count: 0,
  filters: null,
});
